import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/layout/Header';
import Hero from './components/ui/Hero';
import LogoCarousel from './components/ui/LogoCarousel';
import Demo from './components/ui/Demo';
import Integration from './components/ui/Integration';
import Knowledge from './components/ui/Knowledge';
import About from './components/ui/About';
import Waitlist from './components/ui/Waitlist';
import Footer from './components/layout/Footer';
import WatchDemoSqueeze from './components/ui/WatchDemoSqueeze';
import SurveyPopup from './components/ui/SurveyPopup';
import CookieConsent from './components/ui/CookieConsent';
import { logSetupStatus } from './config/services';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);
  const [isSurveyPopupOpen, setIsSurveyPopupOpen] = useState(false);
  const [surveyTriggeredFromWaitlist, setSurveyTriggeredFromWaitlist] = useState(false);

  // Log setup status on app load
  useEffect(() => {
    logSetupStatus();
  }, []);

  // Prevent body scrolling when any popup is open
  useEffect(() => {
    if (isPopupOpen || isVideoPopupOpen || isSurveyPopupOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isPopupOpen, isVideoPopupOpen, isSurveyPopupOpen]);

  // Helper function to get stored email
  const getStoredEmail = () => {
    return sessionStorage.getItem('userEmail') || '';
  };

  const openPopup = () => {
    // TEMPORARILY DISABLED: Always open WatchDemoSqueeze until full demo is ready
    // Previously checked if user had email stored and opened VideoSqueeze directly
    // const storedEmail = getStoredEmail();
    // if (storedEmail) {
    //   setIsVideoPopupOpen(true);
    // } else {
    //   setIsPopupOpen(true);
    // }
    setIsPopupOpen(true);
  };
  
  const closePopup = () => setIsPopupOpen(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used when VideoSqueeze is re-enabled
  const closeVideoPopup = () => setIsVideoPopupOpen(false);
  
  const openSurveyPopupDirect = () => {
    setSurveyTriggeredFromWaitlist(false);
    setIsSurveyPopupOpen(true);
  };
  
  const openSurveyPopupFromWaitlist = () => {
    setSurveyTriggeredFromWaitlist(true);
    setIsSurveyPopupOpen(true);
  };
  
  const closeSurveyPopup = () => setIsSurveyPopupOpen(false);

  return (
    <div className="App">
      <Header onTryForFreeClick={openPopup} onRequestDemoClick={openSurveyPopupDirect} onSurveyTrigger={openSurveyPopupFromWaitlist} />
      <main>
        <Hero onRequestDemoClick={openSurveyPopupDirect} onSurveyTrigger={openSurveyPopupFromWaitlist} />
        <LogoCarousel />
        <Knowledge />
        <Integration onTryForFreeClick={openPopup} onRequestDemoClick={openSurveyPopupDirect} />
        <Demo />
        <About />
        <Waitlist onSurveyTrigger={openSurveyPopupFromWaitlist} />
      </main>
      <Footer />
      <WatchDemoSqueeze isOpen={isPopupOpen} onClose={closePopup} />
      {/* TEMPORARILY DISABLED: Re-enable when full demo is ready */}
      {/* <VideoSqueeze isOpen={isVideoPopupOpen} onClose={closeVideoPopup} userEmail={getStoredEmail()} /> */}
      <SurveyPopup isOpen={isSurveyPopupOpen} onClose={closeSurveyPopup} userEmail={getStoredEmail()} triggeredFromWaitlist={surveyTriggeredFromWaitlist} />
      <CookieConsent />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
